import { FontSize } from '@frontend/atoms/appearanceAtom';

import httpClient from '../http';

export type UserPreferences = {
  user_email: string;
  font_size: FontSize;
  tts_language_code: string;
  tts_voice: string;
  tts_style: string;
  tts_speed: number;
  tts_wake_word_enabled: boolean;
};

/**
 * All fields optional. The backend treats omitted fields as "no change",
 * so the Appearance page can patch font_size without disturbing voice
 * settings and vice versa.
 */
export type UpdateUserPreferencesRequest = {
  font_size?: FontSize;
  tts_language_code?: string;
  tts_voice?: string;
  tts_style?: string;
  tts_speed?: number;
  tts_wake_word_enabled?: boolean;
};

export const userPreferencesService = {
  getUserPreferences: async (): Promise<UserPreferences> => {
    const response = await httpClient.get<UserPreferences>(`/backend/api/v1/user-preferences`);
    return response.data;
  },

  updateUserPreferences: async (prefs: UpdateUserPreferencesRequest): Promise<UserPreferences> => {
    const response = await httpClient.put<UserPreferences>(
      `/backend/api/v1/user-preferences`,
      prefs
    );
    return response.data;
  },
};
